// Beta 1.0.5 · Right-side VANGUARD rail UI controls
// ---------------------------------------------------
// EDIT THIS FILE for manual fine tuning.
// These values are applied as inline CSS custom properties on the rail itself,
// so old CSS blocks and media queries cannot silently override them.

export const MULTIPLIER_RAIL_UI = Object.freeze({
  // Full rail scale. Increase/decrease this for the whole 1X/3X/5X/10X/100X column.
  scaleBase: '1.144',

  // Tiny global scale adjustment. 1.02 = +2%, 0.98 = -2%.
  fine: '1',

  // Base position from the right side of the viewport.
  right: 'clamp(116px, 7.9vw, 158px)',

  // Manual nudges. Positive X moves right, negative X moves left.
  x: '0px',

  // Positive Y moves down, negative Y moves up.
  y: '0px',

  width: 'clamp(82px, 6.35vw, 108px)',
  gap: 'clamp(11px, 1.25vh, 17px)',
  paddingY: 'clamp(15px, 1.16vw, 20px)',
  paddingX: 'clamp(9px, 0.85vw, 14px)',
  buttonSize: 'clamp(54px, 4.55vw, 76px)',
  buttonFontSize: 'clamp(11px, 0.92vw, 15px)',
});

export const GECKO_BUTTON_UI = Object.freeze({
  scale: '0.70',
  x: '0px',
  y: '33px',
});
